import React from 'react'

export default function Loader({is_loader}) {
    return (
        is_loader ? 
        <div id="global-loader">
            <div className="page-loader"></div>
        </div>
        : <></>
    )
}
